import JSZip from "jszip";
import { saveAs } from "file-saver";

const xlsxCellSerial = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "AA",
  "AB",
  "AC",
  "AD",
  "AE",
  "AF",
  "AG",
  "AH",
  "AI",
  "AJ",
  "AK",
  "AL",
  "AM",
  "AN",
  "AO",
  "AP",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AV",
  "AW",
  "AX",
  "AY",
  "AZ",
];

const numberToExcelColumn = (n) => {
  let result = "";
  while (n > 0) {
    n--; // n = 第幾個欄位(從 1 開始)，需 -1 再開始計算
    result = String.fromCharCode(65 + (n % 26)) + result;
    n = Math.floor(n / 26);
  }
  return result;
};

const generateExcelColumnsByArray = (arr) => {
  return arr.map((_, index) => numberToExcelColumn(index + 1));
};

const createXlsxColumn = ({ ws, column = null, value = "", styles = {} }) => {
  if (column === null) return;

  let attribute = { value, ...styles };

  Object.entries(attribute).forEach(([key, val]) => {
    ws.getCell(column)[key] = val;
  });
};

const createXlsxCellStyle = ({
  font_sz = 12,
  font_color = "000000",
  font_bold = false,
  font_underline = false,
  wrapText = true,
  align_h = "left",
  fill_color = "ffffff",
  border_color = "000000",
  other = {},
} = {}) => {
  return {
    font: {
      size: font_sz,
      color: { argb: font_color },
      bold: font_bold,
      underline: font_underline,
    },
    alignment: {
      horizontal: align_h,
      vertical: "middle",
      wrapText: wrapText,
    },
    border: {
      top: { style: "thin", color: { argb: border_color } },
      bottom: { style: "thin", color: { argb: border_color } },
      left: { style: "thin", color: { argb: border_color } },
      right: { style: "thin", color: { argb: border_color } },
    },
    fill: {
      type: "pattern",
      pattern: "solid",
      fgColor: {
        argb: fill_color,
      },
    },
    ...other,
  };
};

// 設定欄位寬度
const createColumnWidth = ({ ws, columns = [] } = {}) => {
  columns.forEach((item) => {
    ws.getColumn(item.column).width = item.width;
  });
};

// 設定欄位高度
const createColumnHeight = ({ ws, columns = [] } = {}) => {
  columns.forEach((item) => {
    ws.getRow(item.column).height = item.height;
  });
};

// 設定合併欄位
const createColumnMerge = ({ ws, columns = [] } = {}) => {
  columns.forEach((item) => {
    ws.mergeCells(item.column);
  });
};

const downloadZip = async ({
  filename = "template",
  fileBlob = [],
  finishAction = () => {},
}) => {
  let zip = new JSZip();

  // 製作檔案
  fileBlob.forEach((item) => {
    zip.file(item.filename, item.blob);
  });

  // 把打包內容非同步轉成blob二進位制格式
  zip
    .generateAsync({ type: "blob" }, function updateCallback(metadata) {})
    .then(function (content) {
      // content就是blob資料，這裡以example.zip名稱下載
      // 使用了FileSaver.js
      saveAs(content, `${filename}.zip`);
      finishAction();
    });
};

const parseSheetName = (name) => {
  let excludeChar = ["*", "?", ":", "：", "\\", "/", "[", "]"];
  excludeChar.forEach((item) => (name = name.replaceAll(item, "")));
  return name;
};

export {
  xlsxCellSerial,
  numberToExcelColumn,
  generateExcelColumnsByArray,
  createXlsxColumn,
  createXlsxCellStyle,
  createColumnWidth,
  createColumnHeight,
  createColumnMerge,
  downloadZip,
  parseSheetName,
};
